import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightFromBracket } from "@fortawesome/pro-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { unsetUser } from "../../features/auth/authSlice";
import { useDispatch } from "react-redux";
import Auth from "../../services/Auth";

function Header() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleLogout = () => {
    Auth.logout();
    dispatch(unsetUser());
  };

  return (
    <div className="py-6 lg:py-12 bg-bioport-blue">
      <div className="container m-auto flex justify-between text-white px-6">
        <div className="">
          <div className="text-2xl">{t("global.settings")}</div>
        </div>
        <div>
          <span
            className="rounded-lg bg-bioport-blue-light border-2 border-bioport-blue hover:bg-bioport-blue hover:border-bioport-blue-light cursor-pointer px-6 py-3 text-sm"
            onClick={() => handleLogout()}
          >
            <FontAwesomeIcon icon={faRightFromBracket} className="" />
          </span>
        </div>
      </div>
    </div>
  );
}

export default Header;
